import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from '../authentication-service/authentication.service';


@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private _authService: AuthenticationService
    ) { }

    canActivate(next: ActivatedRouteSnapshot): boolean {
        if (next.url[0].path === 'login' || next.url[0].path === 'login-dev') {
            // If the user is logged in and he tries to navigate back to the login page then he is not allowed to do so.
            if (this._authService.isLoggedIn()) {
                // User is already logged in
                return false;
            } else {
                return true;
            }
        }

        if (this._authService.isLoggedIn()) {
            return true;
        }

        // User must be logged in
        this._authService.routeToLogin();
        return false;
    }
}
